<template>
    <div>
        <b-form class="step-form" @submit.stop.prevent="onSubmit">
            <div class="row">
                <div class="col-lg-12">
                    <h3>Upload Documents</h3>
                </div>
                <div class="col-lg-12">
                    <div class="row form-options">
                        <!-- <div class="col-lg-6">
                            <utility-bill :field="fieldW8Form"></utility-bill>
                        </div> -->

                        <!-- <div class="col-lg-6">
                        <utility-bill
                            :field="fieldW9Form"
                        ></utility-bill>
                    </div> -->
                        <!-- <div class="col-lg-6">
                            <utility-bill
                                :field="fieldFatcaForm"
                            ></utility-bill>
                        </div> -->
                        <template v-if="addNominee == 'Yes'">
                            <div class="col-lg-6">
                                <utility-bill
                                    :field="fieldNomineeCNIC"
                                ></utility-bill>
                            </div>
                            <div class="col-lg-6">
                                <utility-bill
                                    :field="fieldNomineeCNICBack"
                                ></utility-bill>
                            </div>
                        </template>
                        <div
                            v-if="
                                !fieldZakatAffidavit.show &&
                                !fieldDigitalSignature.show
                            "
                        >
                            <p class="upload-doc-p">
                                No documents to sumbit. Continue to Preview
                                Section...
                            </p>
                        </div>
                        <div v-if="fieldZakatAffidavit.show" class="col-lg-6">
                            <utility-bill
                                :field="fieldZakatAffidavit"
                            ></utility-bill>
                        </div>
                        <div v-if="fieldDigitalSignature.show" class="col-lg-6">
                            <utility-bill
                                :field="fieldDigitalSignature"
                            ></utility-bill>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4"></div>
            </div>
            <div class="">
                <b-button
                    size="sm"
                    variant="secondary"
                    class="mr-3"
                    @click="onBack"
                >
                    Back
                </b-button>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    btn-label="CONTINUE"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                ></base-button>
            </div>

            <!-- <b-modal
                ref="pmda"
                size="md"
                title="Warning"
                hide-footer
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
            >
                <pmda-modal @selection="acceptPmda"></pmda-modal>
            </b-modal> -->
        </b-form>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'

import {
    registrationRequiresW9,
    registrationW9WatchKey,
} from '@/utils/registrationTaxForms'

import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocument from '@/components/registration/IdentityDocument.vue'
import UtilityBill from '@/components/registration/UtilityBill.vue'
import Cropper from '@/components/registration/Cropper.vue'
// import PmdaModal from '@/components/registration/PmdaModal'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        IdentityType,
        IdentityDocument,
        UtilityBill,
        Cropper,
        // PmdaModal,
        // VueCroppie,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            otpData: null,
            is_data_fetched: false,
            showName: 'n-visible',

            fieldZakatAffidavit: {
                isRequired: false,
                isDisable: false,
                isLocked: true,
                show: false,
                key: 'documentInfo.zakatAffidavit.fileName',
                originalFileNameKey:
                    'documentInfo.zakatAffidavit.originalFileName',
                keyBackEnd: 'zakatAffidavit',
                label: 'Zakat Affidavit SCAN COPY',
                urduLabel: 'زکوٰۃ کے حلف نامے کی اسکین کاپی',
                vvName: 'Zakat Affidavit scan copy',
                // hyperLink:
                //     process.env.VUE_APP_API_URL + 'files/docs/zakat-affi.pdf',
                // hyperLinkLabel: 'Download sample',
            },
            fieldDigitalSignature: {
                isRequired: false,
                isDisable: false,
                isLocked: true,
                show: false,
                key: 'documentInfo.digitalSignature.fileName',
                originalFileNameKey:
                    'documentInfo.digitalSignature.originalFileName',
                keyBackEnd: 'digitalSignature',
                label: 'W-9 Digital Signature Copy',
                vvName: 'W-9 Digital Signature Copy',
                urduLabel: 'ڈیجیٹل دستخطی کاپی W-9 ',
                // hyperLink:
                //     process.env.VUE_APP_API_URL +
                //     'files/docs/digital-signature.pdf',
                // hyperLinkLabel: 'Download sample',
            },
            fieldW8Form: {
                isRequired: false,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.w8Form.fileName',
                originalFileNameKey: 'documentInfo.w8Form.originalFileName',
                keyBackEnd: 'w8Form',
                label: 'W-8 form (for Non-US citizen) SCAN COPY',
                urduLabel: 'W-8 فارم (غیر امریکی شہری کے لیے) اسکین کاپی',
                vvName: 'W-8 form (for Non-US citizen) scan copy',
                // hyperLink:
                //     process.env.VUE_APP_API_URL + 'files/docs/W-8-BEN.pdf',
                // hyperLinkLabel: 'Download sample',
            },

            fieldW9Form: {
                isRequired: false,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.w9Form.fileName',
                originalFileNameKey: 'documentInfo.w9Form.originalFileName',
                keyBackEnd: 'w9Form',
                label: 'W-9 form (for Non-US citizen) SCAN COPY',
                urduLabel: 'W-9 فارم (غیر امریکی شہری کے لیے) اسکین کاپی',
                vvName: 'W-9 form (for Non-US citizen) scan copy',
                // hyperLink:
                //     process.env.VUE_APP_API_URL + 'files/docs/W-8-BEN.pdf',
                // hyperLinkLabel: 'Download sample',
            },

            fieldNomineeCNIC: {
                isRequired: true,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.nomineeCNIC.fileName',
                originalFileNameKey:
                    'documentInfo.nomineeCNIC.originalFileName',
                keyBackEnd: 'nomineeCNIC',
                label: 'Nominee CNIC FRONT SCAN COPY',
                urduLabel: 'نامزد کردہ CNIC اسکین کاپی',
                vvName: 'Nominee CNIC front scan copy',
            },
            fieldNomineeCNICBack: {
                isRequired: true,
                isDisable: false,
                isLocked: true,
                key: 'documentInfo.nomineeCNICBack.fileName',
                originalFileNameKey:
                    'documentInfo.nomineeCNICBack.originalFileName',
                keyBackEnd: 'nomineeCNICBack',
                label: 'Nominee CNIC BACK SCAN COPY',
                urduLabel: 'نامزد کردہ CNIC BACK اسکین کاپی',
                vvName: 'Nominee CNIC BACK scan copy',
            },
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
            addNominee: (state) =>
                state.registration.form.accountInfo.addNominee,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    },

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */
        async 'form.documentInfo.identity.fileName'(value) {
            // check if the value is not empty
            // and perform action accordintly
            if (this.userOcr && value !== null && value !== undefined) {
                try {
                    const formData = new FormData()
                    formData.append(
                        'filePath',
                        `${process.env.VUE_APP_API_URL}files/customers/${value}`
                    )
                    formData.append('type', 'id')

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    const { data } = await request.post('ocr/', formData, {
                        headers,
                    })

                    if (
                        ['upload-document', 'record-video'].includes(
                            this.$route.name.toString()
                        )
                    ) {
                        this.$store.commit('updateField', {
                            key: 'identityInfo.number',
                            value: data.customer_data.idnumber,
                        })

                        this.$store.commit('updateField', {
                            key: 'identityInfo.expiryDate',
                            value: this.$moment(
                                data.customer_data.dateofexpiry,
                                'D-M-Y'
                            ).isValid()
                                ? this.$moment(
                                      data.customer_data.dateofexpiry,
                                      'D-M-Y'
                                  ).format('YYYY-MM-DD')
                                : '',
                        })

                        let fullName = _.split(data.customer_data.name, ' ')

                        let firstName = fullName.shift()
                        let lastName = fullName.pop()
                        let middleName = fullName.join(' ')

                        this.$store.commit('updateField', {
                            key: 'basicInfo.firstName',
                            value: firstName,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.middleName',
                            value: middleName,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.lastName',
                            value: lastName,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.dateOfBirth',
                            value: this.$moment(
                                data.customer_data.dob,
                                'D-M-Y'
                            ).isValid()
                                ? this.$moment(
                                      data.customer_data.dob,
                                      'D-M-Y'
                                  ).format('YYYY-MM-DD')
                                : '',
                        })
                    }
                } catch (error) {
                    // console.log(error)
                }
                this.$store.commit('setLoading', false)
            }
        }, // End of user() method
    }, // End of Component > computed

    created() {
        this.$store.watch(
            (state) => registrationW9WatchKey(state.registration.form)
        )
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        window.fbq('track', 'PageView')
        this.$store.dispatch('trackEvent', {
            event: 'JS | SSA Register Upload Documents',
        })

        if (this.fieldZakatAffidavit.keyBackEnd == 'zakatAffidavit') {
            let religion =
                this.$store.state.registration.form.basicInfo.religion
            let zakatOption =
                this.$store.state.registration.form.basicInfo.zakat
            // console.log("zakat ", zakatOption)
            if (
                religion &&
                religion == 'Muslim' &&
                zakatOption &&
                zakatOption == 'No'
            ) {
                this.fieldZakatAffidavit.show = true
                this.fieldZakatAffidavit.isRequired = true
            } else {
                this.fieldZakatAffidavit.show = false
                this.fieldZakatAffidavit.isRequired = false
            }
        }

       
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        

        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */

        checkIsInvalid() {
            let newValue = this.$store.state.registration.form.ssaForms
            let invalidFormNames = []
            let invalidForm = false
            for (let key in newValue) {
                if (newValue.hasOwnProperty(key)) {
                    // console.log(key + ' -> ' + newValue[key]['valid'])
                    if (newValue[key]['valid'] == false) {
                        invalidForm = true
                        invalidFormNames.push(newValue[key]['name'])
                    }
                }
            }
            return invalidForm
        },

        routing() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    // name: 'public-registration-record-video',
                    name: 'public-registration-preview-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                // this.$router.push('/register-customer/record-video')
                this.$router.push('/ssa-customer/preview')
                // this.$router.push('/register-customer/risk-product')
            }
        },
        async onSubmit() {
            //this.$router.push('/register-customer/KYC')
            // validate the form fields
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                this.$store.commit('updateField', {
                    key: 'ssaForms.form6.valid',
                    value: true,
                })
                // console.log(
                //     'this.$store.state.form.forms',
                //     JSON.stringify(this.$store.state.registration.form.ssaForms)
                // )
                let newValue = this.$store.state.registration.form.ssaForms

                let invalidForm = false
                let invalidFormNames = []
                for (let key in newValue) {
                    if (newValue.hasOwnProperty(key)) {
                        // console.log(key + ' -> ' + newValue[key]['valid'])
                        if (newValue[key]['valid'] == false) {
                            invalidForm = true
                            invalidFormNames.push(newValue[key]['name'])
                        }
                    }
                }

                if (!invalidForm) {
                    if (this.$route.meta.publicRegistration === true) {
                        this.$router.push({
                            // name: 'public-registration-record-video',
                            name: 'public-registration-preview-ssa',
                            params: {
                                dataSegmentId: this.dataSegmentId,
                            },
                        })
                    } else {
                        // this.$router.push('/register-customer/record-video')
                        this.$router.push('/ssa-customer/preview')
                        // this.$router.push('/register-customer/risk-product')
                    }
                } else {
                    let msg = 'Kindly fill ' + invalidFormNames[0] + ' Form'

                    this.$store.commit('setError', msg)
                }
            } else {
                this.$store.commit('updateField', {
                    key: 'ssaForms.form6.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
            }
        },

        onBack() {
            // console.log('ON BACK')
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-risk-product-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                // console.log(JSON.stringify(this.selected))
                this.$router.push('/ssa-customer/risk-product')
            }
        },
    }, // End of onSubmit() method
} // End of export default
</script>
